import { render, staticRenderFns } from "./ParametrizacaoContratoPasso6.vue?vue&type=template&id=365462b8&lang=html&"
import script from "./ParametrizacaoContratoPasso6.vue?vue&type=script&lang=js&"
export * from "./ParametrizacaoContratoPasso6.vue?vue&type=script&lang=js&"
import style0 from "./ParametrizacaoContratoPasso6.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VBtn,VCardTitle,VCol,VDataTable,VLabel,VRow,VSpacer,VSwitch})
